/* GASSISA
=========================================================================================
* Descripción: 
* Historial de cambios:
* ---------------------------------------------------------------------------------------
*    Revisión   | Fecha      | Desarrollador                    | Resumen del cambio
* ---------------------------------------------------------------------------------------
*      1       | 06/04/2025 | Lic. José Luis Aragón Cervantes  | Creación
*      2       | 31/05/2026 | Lic. José Luis Aragón Cervantes  | Apertura de modal sin animación
*      3       | 08/10/2026 | LIC. José Luis Aragón C.                       | Identidad de renglón por uid
*      4       | 10/10/2026 | Lic. José Luis Aragón C.                       | Push-to-talk: el micrófono se escucha mientras se mantiene presionado y entrega el texto al soltar
*              |            |                                  | (clavearticulo ?? folio ?? índice):
*              |            |                                  | el agrupado no trae id y todo
*              |            |                                  | quedaba seleccionado sin avance
* --------------------------------------------------------------------------------------- */

import TextField from "../ui/TextField";
import React, { Fragment, useState, useEffect , useRef} from "react";
import { Modal, Box, Typography, Divider } from "@mui/material";
import { apiBuscarEntradasAgrupadas } from "../../settings/ApiConfig";
import { useLayout } from "../../context/System/LayoutContext";
import { useRequest } from "../../context/System/RequestContext";
import SizeSoftXTablePaginadoFilter from "../leyout/SizeSoftXTablePaginadoFilter";
import useSpeechToText from "../leyout/useSpeechToText";
import BotonVoz from "../leyout/BotonVoz";
import { useSesion } from "../../context/System/SesionContext"
import { getDateStringV2 } from "../../settings/utils.js";

const modalStyle = {
    position: 'fixed',
    top: 0,
    right: '9%',
    width: '81vw',
    height: '100vh',
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
    display: 'flex',
    flexDirection: 'column',
    borderRadius: '9px',
};

const getDataFiltros=()=>(
    {
        clavearticulo:defaultTypes.String,
        descripcion:defaultTypes.String,
        medida:defaultTypes.double,
        existencia:defaultTypes.double,
        pmvb:defaultTypes.double,
        constoventa:defaultTypes.double,
        almacenexhibidor:defaultTypes.string,
    }
);

export default function ModalBuscarEntradasSalidas(props) {
    const { openModal, handleCloseModal, onSelectEntrada, onSelectSalida, tipo } = props;
    const { GetRequest } = useRequest();
    const { handleOpenAlert } = useLayout();

    const { isSupported, hasPermission, isListening, error: speechError, startListening, stopListening, checkPermission } = useSpeechToText({
        onResult: (text) => {
            const cleaned = text.replace(/[.]+$/, '').trim();
            setDataFiltro(cleaned);
            setRowSelect({});
            HandleBuscarArticulosPaginado(cleaned, 0, 50);
            setTimeout(() => filterRef.current?.dispatchEvent(new KeyboardEvent('keydown', { key: 'Enter', bubbles: true })), 100);
        }
    });

    const filterRef = useRef(null);   // combo filtro
    const litaFilterRef = useRef(null);  
    
    const {
        parametrosCajaForm
    } = useSesion();

    const [entradaSeleccionada, setEntradaSeleccionada] = useState({});
    const [listaEntradasSalidasFiltro, setlistaEntradasSalidasFiltro] = useState([]);
    const [dataFiltro, setDataFiltro] = useState("");
    const [totalRegistros, setTotalRegistros] = useState(0);
    const [rowSelect, setRowSelect] = useState({});

    useEffect(() => {
        if (openModal) {
            setDataFiltro("");
            setlistaEntradasSalidasFiltro([]);
            setRowSelect({});
            setTimeout(() => {
                if (filterRef.current && openModal) {
                    filterRef.current.focus();
                    filterRef.current.select();
                }
            }, 0);
        }
    }, [openModal]);

    useEffect(() => {
        if (openModal) checkPermission();
    }, [openModal, checkPermission]);

    const handleChangeFilter = (e) => {
        setRowSelect({});
        setDataFiltro(e.target.value);
    };

    const handleOnKeyDowsFilter = async (e) => {
        const { key } = e;
        switch (key) {
            case "ArrowDown": {
                if(dataFiltro.length===0)
                {
                    return;
                }
                // Patrón buscador artículos: bajar al primer renglón y enfocar tabla.
                if (listaEntradasSalidasFiltro.length > 0) {
                    setRowSelect(listaEntradasSalidasFiltro[0]);
                }
                litaFilterRef.current.focus();
                break;
            }

            case "Enter": {
                setlistaEntradasSalidasFiltro([]);
                if(dataFiltro.length===0)
                {
                    return;
                }
                setRowSelect({});
                await HandleBuscarArticulosPaginado(dataFiltro, 0, 50);
                break;
            }

            default:
                break;
        }
    };

    const HandleBuscarArticulosPaginado = async(filtro, inicial, totalporpagina) => {
        let url="";
        // Usar "TODAS" para obtener todas las entradas del sistema sin filtrar por PC
        const caja = "TODAS";
        
        switch (tipo)
        {
            case "ENTRADA":
                url = apiBuscarEntradasAgrupadas
                .replace("{tipo}", "ENTRADA")
                .replace("{busqueda}", encodeURIComponent(filtro))
                .replace("{pc}", caja)
                .replace("{registroinicial}", inicial)            
                .replace("{totalregistros}", totalporpagina);    
                break;
            case "SALIDA":
                url = apiBuscarEntradasAgrupadas
                .replace("{tipo}", "SALIDA")
                .replace("{busqueda}", encodeURIComponent(filtro))
                .replace("{pc}", caja)
                .replace("{registroinicial}", inicial)            
                .replace("{totalregistros}", totalporpagina);    
                break;
        }

        const response = await GetRequest({
            url,
            loader: "Buscando entradas/salidas",
        });

        if (response.hasError) {
            handleOpenAlert(response.message);
            return;
        }

        const filas = normalizarFilasEntradas(response.result.listaentradas || []);
        setlistaEntradasSalidasFiltro(filas);

        setTotalRegistros(response.result.totalregistros || 0);
        
        // Enfocar primer registro después de cargar
        if (filas.length > 0) {
            setTimeout(() => {
                setRowSelect(filas[0]);
                litaFilterRef.current?.focus();
            }, 100);
        }
    };

    // Rev 3: identidad estable por renglón. El agrupado no trae campo id
    // (todo matcheaba undefined y las flechas se atoraban en el índice 0):
    // clavearticulo primero, luego folio, luego índice sintético.
    const normalizarFilasEntradas = (lista = []) =>
        (Array.isArray(lista) ? lista : []).map((row, idx) => ({
            ...row,
            uid: String(
                row?.uid
                ?? row?.clavearticulo
                ?? row?.sClaveArticulo
                ?? row?.folio
                ?? `fila-${idx}`
            ).trim().toUpperCase() || `fila-${idx}`,
        }));

    const handleChangePartidaSeleccionada = (e) => {
        setEntradaSeleccionada(e);
    };

    const handleCargarEntradaSalida = () => {
        if (!rowSelect?.folio) return;
        if (tipo === "ENTRADA") {
            onSelectEntrada && onSelectEntrada(rowSelect);
        } else if (tipo === "SALIDA") {
            onSelectSalida && onSelectSalida(rowSelect);
        } else {
            onSelectEntrada && onSelectEntrada(rowSelect);
        }
        handleCloseModal();
    };

    const handleDoubleClickRow = (row) => {
        if (!row?.folio) return;
        setRowSelect(row);
        handleCargarEntradaSalida();
    };

    const handleChanceRow=(e)=>{
        setRowSelect(e);
    };

    const handleKeyDown = (event) => {
        const { key } = event;

        // Muy importante: evitar comportamiento doble
        if (key === "ArrowDown" || key === "ArrowUp" || key === "Enter") {
            event.preventDefault();
            event.stopPropagation();
        }

        // Si no hay datos, no hace nada
        if (!listaEntradasSalidasFiltro || listaEntradasSalidasFiltro.length === 0) return;

        const currentIndex = listaEntradasSalidasFiltro.findIndex(
            (x) => x.uid === rowSelect?.uid
        );

        switch (key) {
            case "ArrowDown": {
                // Si no hay selección, seleccionar el primero
                if (currentIndex === -1) {
                    handleChanceRow(listaEntradasSalidasFiltro[0]);
                    return;
                }

                // Si no estamos en el último, bajar uno
                if (currentIndex < listaEntradasSalidasFiltro.length - 1) {
                    handleChanceRow(listaEntradasSalidasFiltro[currentIndex + 1]);
                }
                // aquí después puedes meter lógica para ir a "medidas" si estés en el último
                break;
            }

            case "ArrowUp": {
                // Si no hay selección, seleccionar el último
                if (currentIndex === -1) {
                    handleChanceRow(
                        listaEntradasSalidasFiltro[listaEntradasSalidasFiltro.length - 1]
                    );
                    return;
                }

                // Si no estamos en el primero, subir uno
                if (currentIndex > 0) {
                    handleChanceRow(listaEntradasSalidasFiltro[currentIndex - 1]);
                } else {
                    // Primer row -> enfocar filtro y seleccionar texto (patrón buscador artículos)
                    if (filterRef.current) {
                        filterRef.current.focus();
                        filterRef.current.select();
                    }
                }
                break;
            }

            case "Enter": {
                if (rowSelect?.folio) {
                    handleCargarEntradaSalida();
                }
                break;
            }

            default:
                break;
        }
    };

    return (
        <Modal
            open={openModal}
            onClose={(event, reason) => {
                if (reason === "backdropClick") return;
                handleCloseModal();
            }}
            aria-labelledby="menu-modal-title"
            aria-describedby="menu-modal-description"
        >
            <Box sx={modalStyle}>
                <Fragment>
                    <div className="bannerbuscadorarticulos">
                        <p className="titulobuscadorarticulos">Buscador de formatos</p>
                        <div className="filtrobuscadorarticulos">
                            <TextField autoComplete="off"
                                name="Filtro"
                                label="Filtro:"
                                inputRef={filterRef}
                                value={dataFiltro}
                                onChange={handleChangeFilter}
                                onFocus={(e) => e.target.select()}
                                onKeyDownCapture={handleOnKeyDowsFilter}
                                type="text"
                                inputProps={{ maxLength: 60, minLength: 3 }}
                                sx={{ margin: '.1rem .1rem', width: '270px' }}
                            />
                            <BotonVoz
                                    isSupported={isSupported}
                                    hasPermission={hasPermission}
                                    isListening={isListening}
                                    onStart={startListening} onStop={stopListening}
                                />
                        </div>
                        <div className="tablaarticulosfiltrados">
                            <div
                                tabIndex={0}
                                ref={litaFilterRef}
                                onKeyDownCapture={handleKeyDown}
                            >
                                <SizeSoftXTablePaginadoFilter
                                    columns={[
                                        { title: "Folio", field: "folio", width: 60 },
                                        { title: "PC", field: "pc", width: 70 },
                                        { title: "Concepto", field: "concepto", width: 120, render: (row) => (
                                            <Typography variant="body2" sx={{ maxWidth: '110px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} title={row.concepto?.trim()}>
                                                {row.concepto?.trim() || ""}
                                            </Typography>
                                        )},
                                        { title: "Renglones", field: "numerodearticulos", width: 60, type: "numeric" },
                                        { title: "Piezas", field: "cantidadarticulos", width: 60, type: "numeric" },
                                        { title: "Almacén", field: "almacenexhibidor", width: 100, render: (row) => (
                                            <Typography variant="body2" sx={{ maxWidth: '90px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} title={row.almacenexhibidor?.trim()}>
                                                {row.almacenexhibidor?.trim() || ""}
                                            </Typography>
                                        )},
                                        { title: "Fecha", field: "fecharegistro", width: 80, render: (row) => getDateStringV2(row.fecharegistro) },
                                        { title: "Status", field: "status", width: 70, render: (row) => (
                                            <Typography 
                                                variant="body2" 
                                                sx={{ 
                                                    fontWeight: 'bold',
                                                    fontSize: '0.6rem',
                                                    color: row.status === 'TR' ? '#2e7d32' : row.status === 'PE' ? '#ed6c02' : '#9e9e9e'
                                                }}
                                            >
                                                {row.status === 'TR' ? 'TERMINADO' : row.status === 'PE' ? 'PENDIENTE' : row.status?.trim()}
                                            </Typography>
                                        )},
                                    ]}
                                    data={listaEntradasSalidasFiltro}
                                    totalDeRegistros={totalRegistros}
                                    id="uid"
                                    row={rowSelect}
                                    setRow={handleChanceRow}
                                    fontSize="small"
                                    rowsPerPageSet={50}
                                    EspaciadorColumnas={1}
                                    ref={litaFilterRef}
                                    onRowDoubleClick={handleDoubleClickRow}
                                />
                            </div>
                        </div>
                        <Divider sx={{ mt: 1, mb: 1 }} />
                        <div style={{ display: 'flex', justifyContent: 'flex-end', padding: '8px 16px', backgroundColor: '#f5f5f5' }}>
                            <Typography variant="body1" sx={{ fontWeight: 'bold', mr: 2 }}>
                                Total Registros:
                            </Typography>
                            <Typography variant="body1" sx={{ fontWeight: 'bold', color: '#1976d2' }}>
                                {totalRegistros}
                            </Typography>
                        </div>
                    </div>
                </Fragment>
            </Box>
        </Modal>
    );
}
